import Page, {Content, ContentTitle} from "./index";
import {ErrorCode} from "./types";
import React from "react";

interface ErrorPageProps {
    code: ErrorCode;
    children: React.ReactNode | React.ReactNode[];
}
export default function ErrorPage({code, children}: ErrorPageProps) {
    return (
        <Page>
            <ContentTitle titleKey={`title_errorCode${code}`} />
            <Content>{children}</Content>
        </Page>
    );
}
